/* DOMNO. portal — referrals and birthdays, wired to the live worker.

   Copy is governed by Outputs/Rewards Portal/rewards-copy-deck.md.
   Banned everywhere: unlock, redeem, points, tier, member, VIP, exclusive, claim, loyalty.
   The scheme is never named on site — it is only ever "your free piece".

   ⚠ WHAT THIS FIXES. The drawer already had a referral screen and a birthday modal and neither was
   connected to anything. `dpBdaySave` opened a "we'll reach out around your birthday" box and wrote
   the date precisely nowhere. The referral code read `customer.metafields.domno.referral_code`,
   which is set on no customer, so every person was shown the literal word YOURCODE and a share link
   to domno.com/r/YOURCODE — a path that does not exist. The three counters were the characters 0, 0
   and 0 typed into the Liquid. This file replaces all of that with the real thing.

   ⚠ IT DOES NOT WRITE INTO #p-rewards, beyond the one birthday row it is asked to. Three modules
   own that panel and they fight if a fourth joins in: thanks.js has the post-review block,
   credits.js owns THE ONE BOX, gift.js owns the CTA labels and the chosen row. So the referred
   hello lands as a MODAL and the rest is confined to #p-referral, which nobody else touches.

   ⚠ THE CODE MUST BE STASHED BEFORE ANYTHING ELSE HAPPENS. Shopify's account creation drops the
   query string, so ?ref= is gone by the time a new customer comes out the other side. It is read
   and put in localStorage on the very first paint, on any page, signed in or not, and only spent
   once we have a customer id.

   ⚠ ATTACHING ONLY WORKS BEFORE THEIR FIRST ORDER. The worker refuses afterwards on purpose —
   otherwise every existing customer claims a piece off a mate retrospectively. So the box that
   takes a code is shown to people who have not ordered, and says why to everyone else rather than
   failing at them.

   Reads/writes: GET /api/referral, POST /api/referral/attach, GET+POST /api/birthday. */
(function(){
  var API   = 'https://rewards.domno.com';
  var STASH = 'dp_ref_code';

  /* a referral code and nothing else. See the collision below — this pattern is the whole guard. */
  var CODE_RE = /^DOM-[A-Z0-9]{4,8}$/;

  /* ---------- stash the code the moment we see it, before anything can drop it ----------

     ⚠ ?ref= IS NOT OURS ALONE. Loox opens its review form with /products/<handle>?ref=review, and
     the first version of this file swallowed ANY ?ref= value and stripped it from the URL — so
     every "Review this" button in the portal landed on a product page with the parameter already
     eaten and no review form. Dom found it within the hour: "it does lead to the product page,
     but it doesn't automatically open a 5-star review".
     So: only a value that looks like one of our codes is ever taken, and the parameter is only
     removed when we have actually taken it. Anything else is left completely alone for whoever
     it belongs to. */
  (function grab(){
    try{
      var q = new URLSearchParams(location.search);
      var raw = (q.get('ref') || q.get('REF') || '').trim().toUpperCase();
      if (!raw || !CODE_RE.test(raw)) return;      /* not ours — hands off, leave the URL intact */
      localStorage.setItem(STASH, raw);
      /* take it out of the address bar so it cannot be shared on by accident, and so a refresh
         does not look like a second referral */
      q.delete('ref'); q.delete('REF');
      history.replaceState(null, '', location.pathname + (q.toString() ? '?' + q : '') + location.hash);
    }catch(e){}
  })();

  function stashed(){
    try{
      var v = localStorage.getItem(STASH) || '';
      /* clear anything the old greedy version wrote — 'REVIEW' off a Loox link, most likely */
      if (v && !CODE_RE.test(v)){ localStorage.removeItem(STASH); return ''; }
      return v;
    }catch(e){ return ''; }
  }
  function clearStash(){ try{ localStorage.removeItem(STASH); }catch(e){} }

  function customerId(){
    try{
      if (window.DP_CUSTOMER && window.DP_CUSTOMER.id) return String(window.DP_CUSTOMER.id);
      if (window.__st && window.__st.cid) return String(window.__st.cid);
    }catch(e){}
    return '';
  }
  function customerEmail(){
    try{ return (window.DP_CUSTOMER && window.DP_CUSTOMER.email) || ''; }catch(e){ return ''; }
  }

  async function getJSON(u){
    try{ return await (await fetch(u, { credentials:'omit' })).json(); }catch(e){ return null; }
  }
  async function postJSON(u, body){
    try{
      return await (await fetch(u, { method:'POST', headers:{'Content-Type':'application/json'},
                                     credentials:'omit', body: JSON.stringify(body) })).json();
    }catch(e){ return null; }
  }

  var mine = null;   /* { code, link, friends_joined, friends_shipped } */

  /* ================= the referral screen ================= */

  function set(box, n, label){
    var b = box.querySelector('b'), s = box.querySelector('small');
    if (b) b.textContent = String(n);
    if (s) s.textContent = label;
  }

  function paintRef(){
    if (!mine) return;
    var code = document.getElementById('dp-refcode');
    if (code && code.textContent.trim() !== mine.code) code.textContent = mine.code;

    var link = document.getElementById('dp-reflink');
    /* the Liquid hardcodes domno.com/r/<code>, which 404s. The real one is a query on the
       homepage, which every marketing link already survives. */
    if (link){
      var want = String(mine.link || ('https://domno.com/?ref=' + mine.code)).replace(/^https?:\/\//, '');
      if (link.value !== want) link.value = want;
    }

    var stats = document.querySelectorAll('#p-referral .refstat');
    if (stats.length >= 3){
      var joined  = mine.friends_joined  || 0;
      var shipped = mine.friends_shipped || 0;
      set(stats[0], joined, 'mates joined');
      set(stats[1], Math.max(0, joined - shipped), 'yet to order');
      set(stats[2], shipped, 'pieces earned');
    }
  }

  /* The box for anyone the link lost. It offers them nothing for themselves — their own piece is
     already sitting there — so it is framed as doing their mate a favour. That is the only honest
     pitch left, and it is the one people actually act on. */
  function paintEntry(hasOrdered, already){
    var panel = document.getElementById('p-referral');
    if (!panel) return;

    var html;
    if (already){
      html = '<div class="rw"><div><div class="n">a mate sent you</div>' +
             '<div class="c">nice one. they get a free piece when your first order goes out.</div>' +
             '</div></div>';
    } else if (hasOrdered){
      html = '<div class="rw"><div><div class="n">got sent here by a mate?</div>' +
             '<div class="c">codes go in before your first order. drop us a line at hi@domno.com ' +
             'and we will sort them out.</div></div></div>';
    } else {
      html = '<h3 class="sec">someone send you here?</h3>' +
             '<div class="refbox">' +
               '<div class="c" style="text-align:center;margin:0 0 9px">' +
                 'pop their code in and they get a free piece too. yours is already in here.' +
               '</div>' +
               '<div class="linkrow"><input id="dp-refin" placeholder="DOM-XXXXX" autocomplete="off" ' +
                 'spellcheck="false" maxlength="12">' +
                 '<button type="button" data-dp-refgo>Add it</button></div>' +
               '<div class="c" id="dp-refin-msg" style="text-align:center;margin:8px 0 0;display:none"></div>' +
             '</div>';
    }

    var host = panel.querySelector('[data-dp-refin-host]');
    if (!host){
      host = document.createElement('div');
      host.setAttribute('data-dp-refin-host','1');
      host.style.marginTop = '18px';
      var box = panel.querySelector('.refbox');
      if (box && box.nextSibling) panel.insertBefore(host, box.nextSibling);
      else panel.appendChild(host);
    }
    if (host.getAttribute('data-dp-state') === html) return;   /* idempotent — the drawer repaints */
    host.innerHTML = html;
    host.setAttribute('data-dp-state', html);

    var go = host.querySelector('[data-dp-refgo]');
    if (go) go.addEventListener('click', function(){ submitCode(host); });
    var input = host.querySelector('#dp-refin');
    if (input) input.addEventListener('keydown', function(e){
      if (e.key === 'Enter'){ e.preventDefault(); submitCode(host); }
    });
  }

  var WHY = {
    already_referred:   'you have already got a mate down for this one.',
    self:               'that is your own code.',
    self_email:         'that is your own code.',
    unknown_code:       'no code like that. worth checking it with them.',
    not_a_new_customer: 'codes go in before your first order. email hi@domno.com and we will sort it.',
    bad_args:           'pop the code in first.'
  };

  async function submitCode(host){
    var input = host.querySelector('#dp-refin');
    var msg   = host.querySelector('#dp-refin-msg');
    if (!input) return;
    var code = (input.value || '').trim().toUpperCase();
    if (!code) return;
    var cid = customerId();
    if (!cid) return;

    var go = host.querySelector('[data-dp-refgo]');
    if (go){ go.disabled = true; go.textContent = '…'; }
    var r = await postJSON(API + '/api/referral/attach',
                           { cid: cid, code: code, email: customerEmail() });
    if (go){ go.disabled = false; go.textContent = 'Add it'; }

    if (r && r.attached){
      clearStash();
      paintEntry(false, true);
      try{ if (typeof window.dpCreditsRefresh === 'function') window.dpCreditsRefresh(); }catch(e){}
      welcome();
      load();
      return;
    }
    if (msg){
      msg.style.display = 'block';
      msg.textContent = (r && WHY[r.why]) || 'that did not go through. try again in a minute.';
    }
  }

  /* ---------- the one-time hello for someone who came in on a mate's link ---------- */
  function welcome(){
    if (document.getElementById('dp-ref-veil')) return;
    var v = document.createElement('div');
    v.id = 'dp-ref-veil';
    v.setAttribute('style','position:fixed;inset:0;z-index:2147483647;background:rgba(0,0,0,.55);' +
      'display:flex;align-items:center;justify-content:center;padding:20px;' +
      'font-family:Helvetica,"Helvetica Neue",Arial,sans-serif');
    var card = document.createElement('div');
    card.setAttribute('style','background:#fff;color:#111;max-width:360px;width:100%;padding:22px 20px;' +
      'box-shadow:0 12px 40px rgba(0,0,0,.3);text-align:center;text-transform:uppercase');
    card.innerHTML =
      '<div style="font-family:\'Montserrat\',Helvetica,Arial,sans-serif;font-weight:900;' +
           'font-style:italic;font-size:22px;margin-bottom:8px;color:#ff0000">big up your mate</div>' +
      '<div style="font-size:13px;line-height:1.6;margin-bottom:18px">they sent you here, so there ' +
        'is an extra free piece sitting in your account. one lands for them too, when your first ' +
        'order goes out.</div>' +
      '<button type="button" id="dp-ref-ok" style="display:block;width:100%;padding:14px;border:0;' +
        'background:#111;color:#fff;font-weight:700;font-size:12px;letter-spacing:.06em;' +
        'text-transform:uppercase;cursor:pointer">Have a look</button>';
    v.appendChild(card);
    v.addEventListener('click', function(e){ if (e.target === v) v.remove(); });
    document.body.appendChild(v);
    card.querySelector('#dp-ref-ok').addEventListener('click', function(){
      v.remove();
      try{ if (typeof window.dpGo === 'function') window.dpGo('rewards'); }catch(e){}
    });
  }

  /* ---------- spend a stashed code as soon as we know who they are ---------- */
  async function spendStash(){
    var code = stashed(), cid = customerId();
    if (!code || !cid) return false;
    var r = await postJSON(API + '/api/referral/attach',
                           { cid: cid, code: code, email: customerEmail() });
    /* clear it either way: a code refused once is refused every time, and leaving it in place
       means retrying it on every page load forever */
    clearStash();
    if (r && r.attached){
      try{ if (typeof window.dpCreditsRefresh === 'function') window.dpCreditsRefresh(); }catch(e){}
      welcome();
      return true;
    }
    return false;
  }

  /* ================= birthdays ================= */

  /* The drawer's own dpBdaySave shows a confirmation and saves nothing. Both it and the sus-dog
     easter egg live on window, so they can be replaced from here without retyping the 30KB drawer.
     The gag stays — it is Dom's — it just has a real write behind it now. */
  function wireBirthday(){
    if (typeof window.dpBdaySave !== 'function') return false;
    if (window.__dpBdayWired) return true;
    window.__dpBdayWired = true;

    function pad(n){ return String(n).padStart(2,'0'); }
    async function save(dd, mm){
      var cid = customerId();
      if (!cid) return null;
      return await postJSON(API + '/api/birthday',
                            { cid: cid, birthday: pad(mm) + '-' + pad(dd), email: customerEmail() });
    }
    function read(a, b){
      var x = document.getElementById(a), y = document.getElementById(b);
      return { dd: parseInt((x||{}).value, 10), mm: parseInt((y||{}).value, 10) };
    }
    function soon(dd, mm){
      if (!dd || !mm || mm < 1 || mm > 12 || dd < 1 || dd > 31) return false;
      var now = new Date(), today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      var b = new Date(now.getFullYear(), mm - 1, dd);
      if (b < today) b = new Date(now.getFullYear() + 1, mm - 1, dd);
      return (b - today) / 86400000 <= 7;
    }
    function say(title, body){
      var v = document.getElementById('dp-bdayDoneVeil');
      if (!v) return;
      var q = v.querySelector('.q'), s = v.querySelector('.s');
      if (q && title) q.textContent = title;
      if (s && body)  s.textContent = body;
      v.classList.add('on');
    }
    function judge(r){
      if (r && r.ok) return say('got it 🎂', 'a free piece lands on your birthday every year.');
      if (r && r.error === 'locked')
        return say('hmm', 'we have already got a birthday for you. email hi@domno.com and we will change it.');
      if (r && r.error === 'bad_date') return say('hmm', 'that date does not exist. have another go.');
      return say('hmm', 'that did not save. try again in a minute.');
    }

    window.dpBdaySave = async function(){
      var v = read('dp-bdayDD','dp-bdayMM');
      try{ window.dpCloseC('dp-bdayVeil'); }catch(e){}
      if (soon(v.dd, v.mm)){
        var sus = document.getElementById('dp-susVeil');
        var d = document.getElementById('dp-susDD'), m = document.getElementById('dp-susMM');
        if (d) d.value = v.dd || '';
        if (m) m.value = v.mm || '';
        if (sus){ sus.classList.add('on'); return; }
      }
      judge(await save(v.dd, v.mm));
      paintBirthdayRow();
    };

    window.dpBdayConfirm = async function(){
      var v = read('dp-susDD','dp-susMM');
      try{ window.dpCloseC('dp-susVeil'); }catch(e){}
      judge(await save(v.dd, v.mm));
      paintBirthdayRow();
    };
    return true;
  }

  /* ---------- the row on the Rewards panel that says whether we have it ---------- */
  async function paintBirthdayRow(){
    var cid = customerId();
    if (!cid) return;
    var r = await getJSON(API + '/api/birthday?cid=' + encodeURIComponent(cid));
    if (!r || !r.ok || !r.birthday) return;
    var rows = document.querySelectorAll('#p-rewards .rw');
    for (var i=0;i<rows.length;i++){
      var n = rows[i].querySelector('.n');
      if (!n || !/birthday/i.test(n.textContent)) continue;
      if (rows[i].getAttribute('data-dp-bday') === r.birthday) return;
      var bits = String(r.birthday).split('-');
      n.textContent = 'birthday saved 🎂';
      var c = rows[i].querySelector('.c');
      if (c) c.textContent = 'a free piece lands every ' + bits[1] + '/' + bits[0] + '.';
      var btn = rows[i].querySelector('.btn');
      if (btn) btn.style.display = 'none';
      rows[i].setAttribute('data-dp-bday', r.birthday);
      return;
    }
  }

  /* ================= copy + share ================= */

  function wireShare(){
    window.dpCopyRef = function(){
      var c = document.getElementById('dp-refcode');
      var t = c ? c.textContent.trim() : '';
      if (!t || !navigator.clipboard) return;
      navigator.clipboard.writeText(t);
      var b = document.querySelector('#p-referral .btn.primary.block');
      if (b){ var o = b.textContent; b.textContent = 'Copied ✓';
              setTimeout(function(){ b.textContent = o; }, 1400); }
    };
    window.dpShareRef = function(){
      var i = document.getElementById('dp-reflink');
      if (!i) return;
      var u = 'https://' + String(i.value).replace(/^https?:\/\//, '');
      if (navigator.share){
        navigator.share({ title:'DOMNO.', text:'have a free piece on me', url:u }).catch(function(){});
      } else if (navigator.clipboard){
        navigator.clipboard.writeText(u);
        var b = document.querySelector('#p-referral .linkrow button');
        if (b){ var o = b.textContent; b.textContent = 'Copied ✓';
                setTimeout(function(){ b.textContent = o; }, 1400); }
      }
    };
  }

  /* ================= boot ================= */

  async function load(){
    var cid = customerId();
    if (!cid) return;
    var email = customerEmail();
    var r = await getJSON(API + '/api/referral?cid=' + encodeURIComponent(cid) +
                          (email ? '&email=' + encodeURIComponent(email) : ''));
    if (r && r.ok){ mine = r; window.DP_REFERRAL = r; paintRef(); }
  }

  async function boot(){
    if (!document.getElementById('domno-portal')) return;
    wireShare();
    wireBirthday();

    var already = await spendStash();
    await load();

    /* has this account ordered? the ledger says so without a second Shopify read */
    var ordered = false;
    try{
      var c = window.DP_CREDITS;
      if (!c && customerId()) c = await getJSON(API + '/api/credits?cid=' + encodeURIComponent(customerId()));
      if (c && c.ledger){
        ordered = c.ledger.some(function(x){ return x.reason === 'order'; });
        if (!already) already = c.ledger.some(function(x){ return x.reason === 'referral_joined'; });
      }
    }catch(e){}

    paintEntry(ordered, already);
    paintBirthdayRow();

    /* the drawer paints late and repaints on navigation, so keep watching for a while rather than
       assuming one pass is enough — same pattern as credits.js */
    var n = 0, iv = setInterval(function(){
      n++;
      if (!window.__dpBdayWired) wireBirthday();
      if (mine) paintRef();
      if (n > 300) clearInterval(iv);
    }, 400);
  }

  window.dpReferRefresh = load;

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
